import { combineReducers } from "redux";
import songs from "./queueReducer";
import session from "./sessionReducer";
import library from "./libraryReducer";
import catalog from "./catalogReducer";
import notice from "./noticeReducer";
import preferences from "./preferencesReducer";
import host from "./hostReducer";
import soundSync from "./soundSyncReducer";
import sets from "./setsReducer";
import requests from "./requestsReducer";
import summary from "./summaryReducer";

const rootReducer = combineReducers({
  songs,
  session,
  library,
  catalog,
  notice,
  preferences,
  host,
  soundSync,
  sets,
  requests,
  summary,
});

export default rootReducer;
